import { Injectable, inject } from '@angular/core';
import ColorGradientService from '../services/color-gradient.service';

@Injectable({ providedIn: 'root' })
export default class RainbowColorService {
	private colorGradientService: ColorGradientService = inject(ColorGradientService);
	
	getRainbow() {
		var rb: any = {};
		rb.gradients = null;
		rb.minNum = 0;
		rb.maxNum = 100;
		rb.colours = ['ff0000', 'ffff00', '00ff00', '0000ff'];
		this.setColours(rb, rb.colours);
		return rb;
	}
	
	setColours(rb, spectrum) {
		if (spectrum.length < 2) {
			throw new Error('Rainbow must have two or more colours.');
		} else {
			var increment: any = (rb.maxNum - rb.minNum) / (spectrum.length - 1);
			var firstGradient: any = this.colorGradientService.getColourGradient();
			this.colorGradientService.setGradient(firstGradient, spectrum[0], spectrum[1]);
			this.colorGradientService.setNumberRange(firstGradient, rb.minNum, rb.minNum + increment);
			rb.gradients = [firstGradient];
			
			for (var i = 1; i < spectrum.length - 1; i++) {
				var colourGradient: any = this.colorGradientService.getColourGradient();
				this.colorGradientService.setGradient(colourGradient, spectrum[i], spectrum[i + 1]);
				this.colorGradientService.setNumberRange(colourGradient, rb.minNum + increment * i,
				rb.minNum + increment * (i + 1));
				rb.gradients[i] = colourGradient;
			}
			
			rb.colours = spectrum;
		}
	}
	
	setSpectrum(rb, colors) {
		this.setColours(rb, colors);
		return rb;
	}
	
	setSpectrumByArray(rb, array) {
		this.setColours(rb, array);
		return rb;
	}
	
	colourAt(rb, number) {
		if (isNaN(number)) {
			throw new TypeError(number + ' is not a number');
		} else if (rb.gradients.length === 1) {
			return rb.gradients[0].colourAt(rb.gradients[0], number);
		} else {
			var segment: any = (rb.maxNum - rb.minNum) / (rb.gradients.length);
			var index: any = Math.min(
			Math.floor((Math.max(number, rb.minNum) - rb.minNum) / segment),
			rb.gradients.length - 1);
			return rb.gradients[index].colourAt(rb.gradients[index], number);
		}
	}
	
	colorAt(rb, number) {
		return this.colourAt(rb, number);
	}
	
	setNumberRange(rb, minNumber, maxNumber) {
		if (maxNumber > minNumber) {
			rb.minNum = minNumber;
			rb.maxNum = maxNumber;
			this.setColours(rb, rb.colours);
		} else {
			throw new RangeError(
			'maxNumber (' + maxNumber + ') is not greater than minNumber ('
			+ minNumber + ')');
		}
		return this;
	}
	
	getColorsByCountOfValues(count, isMinudoc) {
		var rainbow: any = this.getRainbow();
		this.setNumberRange(rainbow, 1, count);
		if (isMinudoc) {
			this.setSpectrum(rainbow, ['#153db7', '#e0eaf8']);
		} else {
			this.setSpectrum(rainbow, ['#287638', '#bed5c3']);
		}
		var colors: Array<any> = [];
		for (var i = 0; i < count; i++) {
			colors.push(this.colorAt(rainbow, i + 1));
		}
		return colors;
	}
	
}